export const SidaMark = ({ className }: { className?: string }) => (
  <img
    src="/sida-mark.svg"
    alt="SIDA"
    width={64}
    height={64}
    draggable={false}
    loading="lazy"
    decoding="async"
    className={`select-none ${className ?? ""}`}
  />
);
